<template>
  <div class="Handicap">
    <div class="Handicap-Container">
      <div class="Title">
        <img src="/img/global/handicap.svg" alt="Icon Handicap"/>
        <span>Accessibilité / Handicaps :</span>
      </div>
      <div class="Text">
        Les personnes en situation de handicap souhaitant suivre nos formations sont invitées à
        nous contacter directement afin d'étudier ensemble les solutions.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Handicap",
}
</script>

<style scoped>
/* 
* Global 
*/
.Handicap {
  width: 50%;
  text-align: center;
  margin: auto;
  padding-bottom: 30px;
}

/* 
* Text 
*/
div, span {
  font-size: 16px;
}

.Title span {
  font-weight: bolder;
}

.Title {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 25px;
}

img {
  margin-right: 10px;
}
</style>